import { BaseChart } from '@/components/Charts';

interface Series {
  name?: string;
  data: { y: number; color?: string }[];
}

interface TabConfig {
  label: string;
  value: string;
}

type SeriesByTab = Record<string, Series[]>;

interface PieChartProps {
  title: string;
  subtitle?: string;
  series: Series[] | SeriesByTab;
  formatValue?: (val: number) => string | JSX.Element;
  headerTooltip?: string;
  headerStats?: { label: string; value: number }[];
  tabsList?: TabConfig[];
  hasTotal?: boolean;
  titleClassName?: string;
}

export const PieChart = (props: PieChartProps) => {
  return (
    <BaseChart
      customOptions={{
        chart: {
          type: 'pie',
          spacingTop: 0,
        },
        legend: {
          enabled: true,
          labelFormatter: function () {
            const point = this as Highcharts.Point;
            return `
              <span style="font-size: 14px; font-weight: 600;">${
                point.name
              }</span><br>
              <strong style="font-size: 16px; font-weight: 800;">${Math.round(
                point.percentage ?? 0
              )}%</strong>
            `;
          },
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: false,
            },
            showInLegend: true,
          },
        },
      }}
      isLegendEnabled={true}
      tooltipFormatter={function () {
        const total = (this as any).totalOveride ?? this.y;
        return `
          <div style="font-family: 'Jakarta', sans-serif; padding: 12px;">
            <div style="display: flex; align-items: center; justify-content: space-between; gap: 12px;">
              <div>
                <span style="display: inline-block; width: 8px; height: 8px; border-radius: 50%; background-color: ${
                  this.color
                };"></span>
                <span style="color: #50405E; font-size: 12px; font-weight: 600;">
                  ${this.key}:
                </span>
              </div>
              <div>
                <strong style="color: #3B0764; font-weight: 800; font-size: 14px;">
                   ${total}  (${Math.round(this.percentage)}%)
                </strong>
              </div>
            </div>
        </div>
      `;
      }}
      {...props}
    />
  );
};
